
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ProductPlanModel } from './Entities.GormCrm.ProductPlan';
import { Model, ModelProperty } from 'models/Model';


export class ProductPlanPreparationRequestModel extends Model<ProductPlanPreparationRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'productPlan', type: 'ProductPlanModel', languageString: 'productPlanPreparationRequest.property.productPlan', isHidden: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } },
		{ name: 'totalPlanValue', type: 'number', languageString: 'productPlanPreparationRequest.property.totalPlanValue' },
		{ name: 'accountingPlanSetupId', type: 'guid', languageString: 'productPlanPreparationRequest.property.accountingPlanSetupId' },
		{ name: 'departmentDimension', type: 'string', languageString: 'productPlanPreparationRequest.property.departmentDimension' },
		{ name: 'companyDimension', type: 'string', languageString: 'productPlanPreparationRequest.property.companyDimension' },
		{ name: 'generatedFromSalesOrder', type: 'boolean', languageString: 'productPlanPreparationRequest.property.generatedFromSalesOrder' },
		{ name: 'orderId', type: 'guid', languageString: 'productPlanPreparationRequest.property.orderId' },
		{ name: 'generateInvoicesBasedOnProductPlanId', type: 'guid', languageString: 'productPlanPreparationRequest.property.generateInvoicesBasedOnProductPlanId' },
		{ name: 'startupAmount', type: 'number', languageString: 'productPlanPreparationRequest.property.startupAmount' },
		{ name: 'startupInstallments', type: 'number', languageString: 'productPlanPreparationRequest.property.startupInstallments' },
		{ name: 'numberOfInstallments', type: 'number', languageString: 'productPlanPreparationRequest.property.numberOfInstallments' }
	];
	[key: string]: any;
	
	public productPlan?: ProductPlanModel;
	public totalPlanValue: number;
	public accountingPlanSetupId?: string;
	public departmentDimension: string;
	public companyDimension: string;
	public generatedFromSalesOrder: boolean;
	public orderId?: string;
	public generateInvoicesBasedOnProductPlanId?: string;
	public startupAmount?: number;
	public startupInstallments?: number;
	public numberOfInstallments?: number;
    
	constructor(){
		super();
		this.productPlan = undefined;
		this.totalPlanValue = 0;
		this.accountingPlanSetupId = undefined;
		this.departmentDimension = '';
		this.companyDimension = '';
		this.generatedFromSalesOrder = false;
		this.orderId = undefined;
		this.generateInvoicesBasedOnProductPlanId = undefined;
		this.startupAmount = undefined;
		this.startupInstallments = undefined;
		this.numberOfInstallments = undefined;
		
	}
	getProperties(){
		return ProductPlanPreparationRequestModel.classProperties;
	}
}

